const messages = {
	signUpSuccess: "Successfully registered! You've been signed in as well.",
	signUpFailure:"Registration failed. Username/Email may be taken, or passwords don't match.",
	signInSuccess: 'Welcome!',
	signInFailure:'Failed to sign in. Check your username and password then try again.',
	signOutSuccess: 'Come back soon!',
	changePasswordSuccess: 'Password changed successfully!',
	changePasswordFailure:'Failed to change passwords. Check your old password then try again.',
	indexMeetupSuccess: 'Successfully loaded all meetups!',
	indexMeetupFailure: 'Failed to load all meetups.',
	showMeetupSuccess: 'Successfully loaded the meetup!',
	showMeetupFailure: 'Failed to load the meetup.',
	createMeetupSuccess: 'Successfully created the meetup!',
	createMeetupFailure: 'Failed to create the meetup.',
	updateMeetupSuccess: 'Successfully updated the meetup!',
	updateMeetupFailure: 'Failed to update the meetup.',
	deleteMeetupSuccess: 'Successfully deleted the meetup!',
	deleteMeetupFailure: 'Failed to delete the meetup.',
	indexPetSuccess: 'Successfully loaded all pets!',
	indexPetFailure: 'Failed to load all pets.',
	showPetSuccess: 'Successfully loaded the pet!',
	showPetFailure: 'Failed to load the pet.',
	createPetSuccess: 'Successfully created your pet!',
	createPetFailure: 'Failed to create your pet.',
	updatePetSuccess: 'Successfully updated your pet!',
	updatePetFailure: 'Failed to update your pet.',
	deletePetSuccess: 'Successfully deleted your pet!',
	deletePetFailure: 'Failed to delete your pet.',
	showUserFailure: 'Failed to show this pawrent.',
	addCommentSuccess: 'Successfully added your comment!',
	addCommentFailure: 'Failed to add your comment.',
	updateCommentSuccess: 'Successfully updated the comment!',
	updateCommentFailure: 'Failed to update the comment.',
	deleteCommentSuccess: 'Successfully deleted your comment!',
	deleteCommentFailure: 'Failed to delete the comment.',
}

module.exports = messages